import React from 'react'

function NoAccess() {
    return (
        <div>
          <h1>  You don't have access to this page</h1>  
        </div>
    )
}

export default NoAccess
